import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import globalMiddleware from "../../hocs/globalMiddleware";
import {
    clearOfferCategory,
    clearOfferList,
    clearOfferListAndCategories,
    clearShowMore,
    getOffers
} from "../../store/actions/offerActions";
import {connect} from "react-redux";
import OfferSearch from "../../components/offers/OfferSearch";
import {setCurrentRoute, clearError500} from "../../store/actions/globalActions";
import Maintenance from "../../components/Maintenance";
import Offers from "../../components/offers/Offers";
import DynamicOffersArea from "../../components/offers/DynamicOffersArea";

class Offer extends Component {
    state = {
        limit: 6,
        offset: 0,
        showMoreOffersIsLoading: false,
        isFilter: false,
    };


    initPage = async () => {
        this.props.clearError500();
        await this.props.clearOfferList();
        await this.props.clearOfferListAndCategories();
        await this.props.getOffers(1, null, this.state.limit, 0);
        await this.props.getOffers(0, null, this.state.limit, 0, 1);
        this.props.setCurrentRoute(window.location.href);
    };

    componentDidMount = () => {
        this.initPage();
        window.scrollTo(0, 0);

    };

    handleSetCurrentSearchData = async (clearSearch, type) => {
        this.props.clearOfferList();
        this.props.clearShowMore();
        this.setState({
            offset: 0,
            isFilter: true,
        });
        if (clearSearch === "clear") {
            this.props.clearOfferCategory();
            this.setState({
                offset: 0,
                isFilter: false,
            });
            await this.props.getOffers(1, null, this.state.limit, 0);
            await this.props.getOffers(0, null, this.state.limit, 0, 1);
        } else {
            switch (type) {
                case "all" :
                    this.props.getOffers(0, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset);
                    break;
                case "is_featured" :
                    this.props.getOffers(1, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset);
                    break;
                case "most_viewed" :
                    this.props.getOffers(0, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset, 1);
                    break;
                default:
                    this.props.getOffers(0, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset);
            }
        }
    };

    loadMore = (e, type) => {
        e.preventDefault();
        this.setState({
                offset: this.state.offset + 6,
                showMoreOffersIsLoading: true,
            },
            () => {
                switch (type) {
                    case "all" :
                        this.props.getOffers(0, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset);
                        break;
                    case "is_featured" :
                        this.props.getOffers(1, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset);
                        break;
                    case "most_viewed" :
                        this.props.getOffers(0, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset, 1);
                        break;
                    default:
                        this.props.getOffers(0, this.props.currentOfferCategory ? this.props.currentOfferCategory : null, this.state.limit, this.state.offset);

                }
                this.setState({
                    showMoreOffersIsLoading: false,
                })
            }
        )
    };

    renderOffersTypes = () => {
        if (this.props.featuredOffers && this.props.featuredOffers.length > 0) {
            return (<DynamicOffersArea language={this.props.language}
                                       type="is_featured"
                                       loadMore={(e, type) => this.loadMore(e, type)}
                                       offersListIsLoading={this.props.featuredOffersListIsLoading}
                                       offersList={this.props.featuredOffers} offersLoading={this.props.offersLoading}
                                       noMoreOffers={this.props.noMoreOffers} isFilter={this.state.isFilter}/>)
        } else if (this.props.mostViewedOffers && this.props.mostViewedOffers.length > 0) {
            return (<DynamicOffersArea language={this.props.language}
                                       type="most_viewed"
                                       loadMore={(e, type) => this.loadMore(e, type)}
                                       offersListIsLoading={this.props.mostViewedListIsLoading}
                                       offersList={this.props.mostViewedOffers} offersLoading={this.props.offersLoading}
                                       noMoreOffers={this.props.noMoreOffers} isFilter={this.state.isFilter}/>)
        } else {
            return (<DynamicOffersArea language={this.props.language}
                                       type="all"
                                       loadMore={(e, type) => this.loadMore(e, type)}
                                       offersListIsLoading={this.props.offersListIsLoading}
                                       offersList={this.props.offers} offersLoading={this.props.offersLoading}
                                       noMoreOffers={this.props.noMoreOffers} isFilter={this.state.isFilter}/>)
        }
    };

    render() {

        const {mostViewedOffers, mostViewedListIsLoading, error500} = this.props;
        if (error500) {
            return (
                <Maintenance/>
            )
        }
        return (
            <div id="all-offers">

                <OfferSearch mobileMenuIsShown={this.props.mobileMenuIsShown}
                             getOffers={(is_featured, category_id, limit, offset, most_viewed) => this.props.getOffers(is_featured, category_id, limit, offset, most_viewed)}
                             handleSetCurrentSearchData={(clearSearch, type) => this.handleSetCurrentSearchData(clearSearch, type)}/>
                <section>
                    <div className="container">
                        {
                            !this.state.isFilter && mostViewedOffers && mostViewedOffers.length > 0 ?
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <p className="capitalized offer-sponsored-title">{this.props.translate('top_viewed')}</p>
                                        </div>
                                    </div>
                                    <Offers language={this.props.language} offers={mostViewedOffers}
                                            offersListIsLoading={mostViewedListIsLoading}
                                            isHome={false}/>
                                </div>
                                : null
                        }
                        {this.renderOffersTypes()}
                    </div>
                    {/*   <div hidden={this.state.popUpStatus === false}
                         className="offer-pop-up" id="offer-pop-up">
                        <a href="/" className="closebtn"
                           onClick={(e) => this.changeFormStatus(e, "close")}>&times;</a>
                        <OfferDetails popUpOffer={this.state.currentOffer}/>
                        <img onClick={(e) => this.changeFormStatus(e, "close")}
                             src="/images/offer-close.png"
                             alt="close" className="close-on-mobile cursor-pointer"/>
                    </div>*/}
                </section>
            </div>
        )
    }


}


const mapStateToProps = (state) => {
    return {
        offers: state.offer.offers,
        offersListIsLoading: state.offer.offersListIsLoading,
        featuredOffers: state.offer.featuredOffers,
        featuredOffersListIsLoading: state.offer.featuredOffersListIsLoading,
        mostViewedOffers: state.offer.mostViewedOffers,
        mostViewedListIsLoading: state.offer.mostViewedListIsLoading,
        specialties: state.specialty.specialties,
        specialtyListIsLoading: state.specialty.specialtyListIsLoading,
        offersLoading: state.offer.offersLoading,
        noMoreOffers: state.offer.noMoreOffers,
        currentOfferCategory: state.offer.currentOfferCategory,
        error500: state.global.error500,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOffers: (is_featured, category_id, limit, offset, most_viewed) => dispatch(getOffers(is_featured, category_id, limit, offset, most_viewed)),
        clearOfferListAndCategories: () => dispatch(clearOfferListAndCategories()),
        clearShowMore: () => dispatch(clearShowMore()),
        clearOfferCategory: () => dispatch(clearOfferCategory()),
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearOfferList: () => dispatch(clearOfferList()),
        clearError500: () => dispatch(clearError500())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Offer)))
